<template>
  <BaseDialog
    :open="open"
    role="dialog"
    aria-modal="true"
    @close="onClose"
  >
    <template #title>
      Benutzer
      <span v-if="userLabel">
        ({{ userLabel }})
      </span>
      löschen
    </template>

    <p>Möchten Sie diesen Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.</p>
    <p
      v-if="error"
      class="notice notice-danger mt-12"
      role="alert"
    >
      {{ error }}
    </p>

    <div
      class="actions"
      style="display:flex; gap:8px; justify-content:flex-end; margin-top:16px;"
    >
      <button
        type="button"
        class="btn"
        :disabled="loading"
        @click="onClose"
      >
        Abbrechen
      </button>
      <button
        type="button"
        class="btn btn-warn"
        :disabled="loading"
        @click="onDelete"
      >
        <span
          v-if="loading"
          class="spinner"
          aria-hidden="true"
        /> Löschen
      </button>
    </div>
  </BaseDialog>
</template>

<script setup>
import {ref, computed} from 'vue';
import BaseDialog from '@/components/BaseDialog.vue';
import usersApi from '@/api/users';
import {useToast} from 'primevue/usetoast';

const props = defineProps({
  open: {type: Boolean, default: false},
  id: {type: Number, required: true},
  // optional: vorab übergebener Anzeigename
  name: {type: String, default: ''}
});
const emit = defineEmits(['close', 'deleted']);

const loading = ref(false);
const error = ref(null);
const toast = useToast();

// Anzeige-Label: bevorzugt prop.name, sonst ID-Fallback
const userLabel = computed(() => {
  const name = (props.name || '').trim();
  if (name) return name;
  return `ID ${props.id}`;
});

function onClose() {
  // Fehlerzustand beim Schließen zurücksetzen
  error.value = null;
  emit('close');
}

async function onDelete() {
  loading.value = true;
  error.value = null;
  try {
    if (typeof usersApi.delete === 'function') {
      await usersApi.delete(props.id); // harter DELETE
    } else {
      // falls API-Client keine delete-Methode hat, Soft-Delete als Fallback
      await usersApi.update(props.id, {deleted: true});
    }
    toast.add({severity: 'success', summary: 'Gelöscht.', life: 3500});
    emit('deleted', {id: props.id});
  } catch (e) {
    if (e?.response?.status === 405 || e?.response?.status === 501) {
      try {
        await usersApi.update(props.id, {deleted: true});
        toast.add({severity: 'success', summary: 'Gelöscht.', life: 3500});
        emit('deleted', {id: props.id});
        return;
      } catch (err) {
        error.value = err?.response?.data?.message || 'Löschen fehlgeschlagen.';
      }
    } else {
      error.value = e?.response?.data?.message || 'Löschen fehlgeschlagen.';
    }
  } finally {
    loading.value = false;
  }
}
</script>
